export const NEAR_BOTTOM_THRESHOLD_PX = 96

export function distanceFromBottom(element) {
    if (!element) return 0
    return Math.max(0, element.scrollHeight - element.scrollTop - element.clientHeight)
}

export function isNearBottom(element, threshold = NEAR_BOTTOM_THRESHOLD_PX) {
    return distanceFromBottom(element) < threshold
}

export function shouldAutoScroll(force, pinnedToBottom) {
    return Boolean(force || pinnedToBottom)
}
